"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enError = exports.enEnum = exports.enActivity = exports.deError = exports.deEnum = exports.deActivity = void 0;
const activity_json_1 = __importDefault(require("./de/activity.json"));
exports.deActivity = activity_json_1.default;
const enum_json_1 = __importDefault(require("./de/enum.json"));
exports.deEnum = enum_json_1.default;
const error_json_1 = __importDefault(require("./de/error.json"));
exports.deError = error_json_1.default;
const activity_json_2 = __importDefault(require("./en/activity.json"));
exports.enActivity = activity_json_2.default;
const enum_json_2 = __importDefault(require("./en/enum.json"));
exports.enEnum = enum_json_2.default;
const error_json_2 = __importDefault(require("./en/error.json"));
exports.enError = error_json_2.default;
